'use client';

import { usePathname } from 'next/navigation';
import { IMenuItemConfig, type TMenuConfig } from '../types';

// Basic path matcher: supports dynamic segments like [id] or :id
const matchPath = (pathname: any, configPath: string): boolean => {
  const pathParts: any = pathname?.split('/').filter(Boolean);
  const configParts = configPath?.split('/').filter(Boolean);

  if (pathParts.length !== configParts.length) return false;

  return configParts.every((part, idx) => {
    return part.startsWith('[') || part.startsWith(':') || part === pathParts[idx];
  });
};

const useMenuCurrentItem = (items: TMenuConfig | null): IMenuItemConfig | null => {
  const pathname = usePathname().trim() ?? "/";

  const findCurrentItem = (items: TMenuConfig | null): IMenuItemConfig | null => {
    if (!items) return null;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.path && matchPath(pathname, item.path)) {
        return item;
      } else if (item.children) {
        const childItem = findCurrentItem(item.children as TMenuConfig);
        if (childItem) {
          return childItem;
        }
      }
    }

    return null;
  };

  return findCurrentItem(items);
};

export { useMenuCurrentItem };
